import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../src/config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const sumitAnswerChallenge = createAsyncThunk(
    'get-all-challenge',
    async ({missionAttemptId, payload}, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/users/api/question/update/${missionAttemptId}`,payload)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const sumitAnswerChallengeSlice = createSlice({
    name: 'get-all-challenge',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(sumitAnswerChallenge.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(sumitAnswerChallenge.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(sumitAnswerChallenge.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const sumitAnswerChallengeReducer = sumitAnswerChallengeSlice.reducer
